<template>
  <div class="component-container">
    <div class="second-edition" id="second-edition">
      <h3>2PNG Second Edition: Solving Problems with Properties - Downloads and Resources</h3>
      
      <div class="back-button-wrapper">
        <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
      </div>

      <div class="presentations">
        <h4>Teacher Resources</h4>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2F2PNG-2E_Activities_1-7_08212024.zip?alt=media&token=b42df2e3-7310-462b-a6a0-28844e17f58b" target="_blank">Teacher Presentations: Activities 1 - 7</a> - Updated 8/21/2024</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
      </div>

      <div class="presentations">
        <h4>Student Journals &amp; Assessments</h4>
        <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1UbtRcyuAee6qns9DsdB_mAbHcQlqpkMD3AeUY5dgBcM/copy" target="_blank">2PNG Second Edition: Solving Problems with Properties Student Journal</a></li>
          <li><a href="https://drive.google.com/file/d/1eTMx3y8CnJKZE6ouqrsaeMUl4MeID-ao/view" target="_blank">2PNG Second Edition: Solving Problems with Properties Student Journal Answer Key</a></li>
          <li><a href="https://docs.google.com/presentation/d/193KaD8zFx7EnXafYu0UBk5V7CddnMJIDli3AZ2wB3nc/copy" target="_blank">2PNG Second Edition: Solving Problems with Properties Student Journal - SPANISH</a></li>
        </ul>
        <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2PNG-2E_PrePostAssessment_10212021.pdf?alt=media&token=ba0f01e1-cb2b-49ec-a3ef-28147bef6ca3" target="_blank">2PNG Second Edition Post Assessment - Updated 11/18/2021</a></li>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-dev-926a6.appspot.com/o/unitUpdates%2F2PNG-2E_PrePostAssessment_11042021_converted_ESUS_HR.pdf?alt=media&token=8f99f4eb-647c-4d4d-b3b5-d47536a9272b" target="_blank">2PNG Second Edition Post Assessment (Spanish) - Updated 11/18/2021</a></li>
        </ul>
      </div>
      <div class="presentations">
        <h4>Individual Resources</h4>
        <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1glngUriXm2cpf98MtHZF2omZqdhUHNjk9gZYJdhkUA8/copy" target="_blank">What We Think chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1BAzZMtZotbJvrpOtWXhtPglcMzO8Ey3KXLs_RxqzJUs/copy" target="_blank">Word Sort Cards - Lesson 1B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1u2hoz9hwVk1U-532Rd8veZdNsouiypZpN7oB7lZ76Yw/copy" target="_blank">Word Wall</a></li>
          <li><a href="https://docs.google.com/presentation/d/1010V-P5-Agsrqi0R3PbKHstlVMgWvFtKy4N4SkoxpcA/copy" target="_blank">Word Sort Cards - Lesson 2B</a></li>
          <li><a href="https://docs.google.com/presentation/d/1aoEIANfYjWhKPyqOn2Ggus6fiPOCr8rsznDSCbrweXc/copy" target="_blank">Word Sort Cards - Lesson 3B</a></li>
          
          <!-- <li><a href="" target="_blank"></a></li> -->

        </ul>
       
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="css" scoped>
.presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
}
ul {
  list-style: none;
}
.presentations a {
  margin-left: 40px;
}
li {
  margin-left: -40px;
}
.back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
}
.back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
}
</style>
